package article.spring

import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp



val springYellow = Color(0xfff9e7bb)
val springPink = Color(0xffe97cbb)
val springPurple = Color(0xff3d47d9)

@Composable
fun Orb(
    modifier: Modifier = Modifier,
    glow: Boolean = false,
) {
    val shadowDp by animateDpAsState(
        targetValue = if (glow) 20.dp else 0.dp
    )
    val rotationTransition = rememberInfiniteTransition()
    val rotation by rotationTransition.animateFloat(
        initialValue = 0f,
        animationSpec = infiniteRepeatable(
            animation = tween(10_000, easing = LinearEasing),
            repeatMode = RepeatMode.Restart
        ),
        targetValue = 360f,
    )
    Box(
        modifier
            .rotate(rotation)
            .shadow(
                shadowDp,
                spotColor = Color(0xfff9e7bb),
                ambientColor = Color.Cyan,
                shape = CircleShape,
            )
            .background(
                Brush.linearGradient(
                    listOf(
                        Color(0xfff9e7bb),
                        Color(0xffe97cbb),
                        Color(0xff3d47d9),
                    )
                ), CircleShape
            )
    )
}